import { createSelector } from '@ngrx/store';
import { selectSessionId } from './session.selectors';
import {
  SessionStatus,
  UpdateTransactionStatusRequestV1,
} from '@arc/unified-payments-frontend/shared-payment';
import { selectTenantId } from '../../external-selectors';

export const selectUpdateTransactionStatusSuccessRequestData = createSelector(
  selectTenantId,
  selectSessionId,
  (tenantId, sessionId) => {
    const request: UpdateTransactionStatusRequestV1 = {
      status: SessionStatus.Success,
    };
    return { tenantId, sessionId, request };
  },
);

export const selectUpdateTransactionStatusActiveRequestData = createSelector(
  selectTenantId,
  selectSessionId,
  (tenantId, sessionId) => {
    const request: UpdateTransactionStatusRequestV1 = {
      status: SessionStatus.Active,
    };
    return { tenantId, sessionId, request };
  },
);
